import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom'
import { Divider, message, Button} from 'antd';
import API from '@api/api.js';
import UpdatePasswordModal from '@view/compoents/personalCenterModal/updatePasswordModal'
import BindWechatModal from '@view/compoents/personalCenterModal/bindWechatModal';
import { AppContext } from '@utils/AppContext';
import styles from './index.module.scss'
import eventBus from '@utils/eventBus';
import PSAIModal from '@PSAIComponents/PSAIModal';
import dayjs from 'dayjs';
import Utils from '@utils/utils';
import TopWrap from '../hooks/TopWrap';

const PersonalInformation = () => {
    const { globalUser, setGlobalUser, globalActivity, updateConfig, setGlobalLoading } = useContext(AppContext);
    const [info, setInfo] = useState();
    const [plansList, setPlansList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [orderList, setOrderList] = useState([]);
    const [orderLoading, setOrderLoading] = useState(false)
    const [logList, setLogList] = useState([])
    const [logLoading, setLogLoading] = useState(false)
    const [wechatModal, setWechatModal] = useState(false)
    const [pwdOpen, setPwdOpen] = useState(false)
    const [powerList, setPowerList] = useState([])
    const [alipayOpen, setAlipayOpen] = useState(false)
    const [alipayItems, setAlipayItems] = useState()
    const [isPowerPackage, setIsPowerPackage] = useState(false)
    const [loading, setLoading] = useState(false)
    const [imageUrl, setImageUrl] = useState();
    const navigate = useNavigate()
    const payChildRef = useRef(null);

    useEffect(() => {
        API.userInfo({}).then((res) => {
            if (res.code == 0) setGlobalUser({
                ...res.data
            })
        })
    }, [])

    // 活动状态 0-未开始 1-进行中 2-已结束
    const ACTIVITY_240711_STATUS = useMemo(() => {
        if (!globalActivity) return 0
        const activity = globalActivity.ACTIVITY_240711
        const now = dayjs()
        const start = dayjs(activity.beginAt)
        const end = dayjs(activity.endAt)
        return now.isBefore(start) ? 0 : now.isAfter(end) ? 2 : 1
    })

    const copyFun = (link) => {
        if (!link) return;

        const fullLink = link;

        // 如果 clipboard API 可用
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(fullLink)
                .then(() => {
                    message.success('复制成功');
                })
                .catch(err => {
                    console.error('Clipboard error:', err);
                    message.error('复制失败，请手动复制');
                });
        } else {
            // 兼容旧浏览器
            const textarea = document.createElement('textarea');
            textarea.value = fullLink;
            textarea.style.position = 'fixed';
            textarea.style.top = '-9999px';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();

            try {
                const success = document.execCommand('copy');
                if (success) {
                    message.success('复制成功');
                } else {
                    message.warning('复制失败，请手动复制');
                }
            } catch (err) {
                console.error('Fallback copy error:', err);
                message.error('复制失败，请手动复制');
            }

            document.body.removeChild(textarea);
        }
    };

    const refreshState = () => {
        eventBus.emit('updateUserInfo')
        eventBus.emit('getUserOrgInfo')
        eventBus.emit('updateActivityInfo')
    }

    useEffect(() => {
        refreshState()
    }, [])

    const unregisterClick = () => {
        PSAIModal.confirm({
            content: <div className={styles.unregisterModal}>
                <p>请确认是否注销账号？确认后不可找回！</p>
                <p>
                    <span>确定即表示您已阅读并同意本产品的</span>
                    <a target='_blank' href='/注销须知.htm'>注销须知</a>
                </p>
            </div>,
            okText: '注销',
            cancelText: '取消',
            onOk: unregisterUser,
            onCancel() { },
        })
    }

    const unregisterUser = () => {
        setGlobalLoading('注销中')
        API.unregisterUser({}).then((res) => {
            if (res.code == 0) {
                navigate('/')
                localStorage.removeItem('token')
                Utils.clearAllTaskCache()
                localStorage.removeItem('channel')
                sessionStorage.removeItem('lastRouteClothes')
                sessionStorage.removeItem('lastRouteCommodity')
                sessionStorage.removeItem('imgResizeCache')
                message.success('账号已注销')
            } else message.error(res.message)
        }).catch(err => {
            console.error(err)
        }).finally(() => {
            setGlobalLoading(false)
        })
    }


    return (
        <div style={{ height: '100%' }}>
            <TopWrap />
            <div className={styles.personalInformation}>
                <div className={styles.informationWrap}>
                    <div className={styles.messag_box}>
                        <p className={styles.messag_box_p1}>{globalUser?.mobile ? '更换' : '绑定'}手机号</p>
                        <p className={styles.messag_box_p2}><span>{globalUser?.mobile?.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}</span><span onClick={() => eventBus.emit('bindOrChangeMobile')}>{globalUser?.mobile ? '修改' : '绑定'}</span></p>
                    </div>
                    {
                        Utils.getCurrentDomainAndCheckTiktok() &&
                        <>
                            <Divider />
                            <div className={styles.messag_box}>
                                <p className={styles.messag_box_p1}>{globalUser?.email ? '更换' : '绑定'}邮箱</p>
                                <p className={styles.messag_box_p2}><span className={styles.ellipsis}>{globalUser?.email}</span><span onClick={() => eventBus.emit('bindOrChangeEmail')}>{globalUser?.email ? '修改' : '绑定'}</span></p>
                            </div>
                        </>
                    }
                    <Divider />
                    <div className={styles.messag_box}>
                        <p className={styles.messag_box_p1}>账号密码</p>
                        <p className={styles.messag_box_p2}><span>******</span><span onClick={() => setPwdOpen(true)}>{localStorage.getItem('noPassword') == 'true' ? '设置' : '修改 '}</span></p>
                    </div>
                    <Divider />
                    <div className={styles.messag_box}>
                        <p className={styles.messag_box_p1}>第三方登录</p>
                        <p className={styles.messag_box_p2}><span>
                            <img style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                src={require(`@assets/images/${globalUser?.thirdPartyLoginChannel.length > 0 ? 'wechat1.png' : 'wechat2.png'}`)} alt="" />
                        </span><span onClick={() => setWechatModal(true)}>绑定</span></p>
                    </div>
                    <Divider />
                    {
                        <div className={styles.messag_box}>
                            <p className={styles.messag_box_p1}>邀请链接</p>
                            <p className={styles.messag_box_p2}><span>{Utils.getInviteLink(globalUser?.invitationCode)}</span><span onClick={() => copyFun(Utils.getInviteLink(globalUser?.invitationCode))}>复制</span></p>
                        </div>
                    }
                    <Button
                        className={styles.unregisterButton}
                        size='small'
                        onClick={unregisterClick}>
                        注销账号</Button>
                </div>


                <UpdatePasswordModal open={pwdOpen} closeFunc={() => setPwdOpen(false)} />
                <BindWechatModal
                    open={wechatModal}
                    closeFunc={() => { refreshState(); setWechatModal(false) }}
                    thirdPartyLoginChannel={globalUser?.thirdPartyLoginChannel?.length > 0 ? true : false}
                />
            </div>
        </div>

    )
}

export default PersonalInformation
